import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 bg-olive text-white">
      <div className="container">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-4 text-xl font-bold font-serif">
              Лесная Усадьба
            </h3>
            <p className="mb-4">
              Уютная фотолокация в стиле фармхаус для создания атмосферных
              снимков в любое время года в Подмосковье.
            </p>
            <div className="flex space-x-4">
              {/* <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:text-linen"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 256 256"
                >
                  <g
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="10"
                    strokeDasharray=""
                    strokeDashoffset="0"
                    fontFamily="none"
                    fontWeight="none"
                    fontSize="none"
                    textAnchor="none"
                    style={{ mixBlendMode: "normal" }}
                  >
                    <g transform="scale(8.53333,8.53333)">
                      <path d="M15,3c-6.627,0 -12,5.373 -12,12c0,2.25121 0.63234,4.35007 1.71094,6.15039l-1.60352,5.84961l5.97461,-1.56836c1.74732,0.99342 3.76446,1.56836 5.91797,1.56836c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12zM10.89258,9.40234c0.195,0 0.39536,-0.00119 0.56836,0.00781c0.214,0.005 0.44692,0.02067 0.66992,0.51367c0.265,0.586 0.84202,2.05608 0.91602,2.20508c0.074,0.149 0.12644,0.32453 0.02344,0.51953c-0.098,0.2 -0.14897,0.32105 -0.29297,0.49805c-0.149,0.172 -0.31227,0.38563 -0.44727,0.51563c-0.149,0.149 -0.30286,0.31238 -0.13086,0.60938c0.172,0.297 0.76934,1.27064 1.65234,2.05664c1.135,1.014 2.09263,1.32561 2.39063,1.47461c0.298,0.149 0.47058,0.12578 0.64258,-0.07422c0.177,-0.195 0.74336,-0.86411 0.94336,-1.16211c0.195,-0.298 0.39406,-0.24644 0.66406,-0.14844c0.274,0.098 1.7352,0.8178 2.0332,0.9668c0.298,0.149 0.49336,0.22275 0.56836,0.34375c0.077,0.125 0.07708,0.72006 -0.16992,1.41406c-0.247,0.693 -1.45991,1.36316 -2.00391,1.41016c-0.549,0.051 -1.06136,0.24677 -3.56836,-0.74023c-3.024,-1.191 -4.93108,-4.28828 -5.08008,-4.48828c-0.149,-0.195 -1.21094,-1.61031 -1.21094,-3.07031c0,-1.465 0.76811,-2.18247 1.03711,-2.48047c0.274,-0.298 0.59492,-0.37109 0.79492,-0.37109z"></path>
                    </g>
                  </g>
                </svg>
              </a> */}
              <a
                href="https://t.me/Giulia_Ko"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:text-linen"
                aria-label="Telegram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M9.417 15.181l-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.541-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.431 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-xl font-bold font-serif">Навигация</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-linen transition-colors">
                  Главная
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="hover:text-linen transition-colors"
                >
                  Галерея
                </Link>
              </li>
              <li>
                <Link
                  to="/#about"
                  className="hover:text-linen transition-colors"
                >
                  О нас
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="hover:text-linen transition-colors">
                  Вопросы и ответы
                </Link>
              </li>
              <li>
                <Link
                  to="/#contacts"
                  className="hover:text-linen transition-colors"
                >
                  Контакты
                </Link>
              </li>
              <li>
                <Link
                  to="/sitemap"
                  className="hover:text-linen transition-colors"
                >
                  Карта сайта
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-xl font-bold font-serif">Контакты</h3>
            <p className="mb-2">
              <strong>Адрес:</strong> Солнечногорский район, Московская область
            </p>
            <p className="mb-2">
              <strong>Telegram:</strong>{" "}
              <a
                href="https://t.me/Giulia_Ko"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-linen transition-colors"
              >
                @Giulia_Ko
              </a>
            </p>
            <p>
              <strong>Часы работы:</strong> Ежедневно с 9:00 до 21:00 по
              предварительной записи
            </p>
            <p className="mt-4 text-sm">
              <strong>Регион:</strong> Московская область, Солнечногорский
              район, ~60 км от МКАД
            </p>
          </div>
        </div>

        <div className="pt-8 mt-8 text-center border-t border-white/20">
          <p>© {currentYear} Лесная Усадьба. Все права защищены.</p>
          <p className="mt-2 text-sm text-white/70">
            <Link to="/sitemap" className="hover:text-linen transition-colors">
              Карта сайта
            </Link>
            <span className="mx-2">|</span>
            <span>Фотолокация</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
